export default {"src":"/_next/static/media/scope_logo_rgb_white.64274591.svg","height":71,"width":304,"blurWidth":0,"blurHeight":0};